module.exports = __webpack_public_path__ + "84518599d382334f09e67ade7fc530a0.woff2";